export default __webpack_public_path__ + "static/media/pantry2-after2-768w.8b0281d7.avif";